export default "__VITE_ASSET__BsCsN$ar__"